
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insureyourcar",
      function () {
        return require("private-next-pages/insureyourcar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insureyourcar"])
      });
    }
  